__turbopack_context__.v({
  "dash": "style-module-scss-module__ZoS4Qa__dash",
  "root": "style-module-scss-module__ZoS4Qa__root",
});
